/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseSplitPanelDoubleImageBlockFragment} from '@amblique/contentful/app/contentful/fragments/split-panel-double-image-block/base-split-panel-double-image-block.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {RichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/rich-text-block.fragment';
import {VideoFragment} from '@amblique/contentful/app/contentful/fragments/video/video.fragment';

export const FullSplitPanelDoubleImageBlockFragment = gql`
  ${BaseSplitPanelDoubleImageBlockFragment}
  ${ImageFragment}
  ${RichTextBlockFragment}
  ${VideoFragment}

  fragment FullSplitPanelDoubleImageBlockFragment on SplitPanelDoubleImageBlock {
    ...BaseSplitPanelDoubleImageBlockFragment

    primaryImage {
      ... on Image {
        ...ImageFragment
      }
      ... on Video {
        ...VideoFragment
      }
    }
    contentCollection {
      items {
        __typename
        ... on Image {
          ...ImageFragment
        }
        ... on RichTextBlock {
          ...RichTextBlockFragment
        }
        ... on Video {
          ...VideoFragment
        }
      }
    }
  }
`;
